import {ROLES} from '@/enums/roles';

export const NOTIFICATION_TYPES = {
  QUOTE: 'quote',
  BOOKING: 'booking',
  REQUEST: 'request',
  DECISION: 'decision',
  DEADLINE: 'deadline',
  SYSTEM: 'system',
};
export const NOTIFICATION_TYPE_ICONS = {
  [NOTIFICATION_TYPES.QUOTE]: 'mdi-file-document-outline',
  [NOTIFICATION_TYPES.BOOKING]: 'mdi-calendar-check',
  [NOTIFICATION_TYPES.REQUEST]: 'mdi-clipboard-text-outline',
  [NOTIFICATION_TYPES.DECISION]: 'mdi-gavel',
  [NOTIFICATION_TYPES.DEADLINE]: 'mdi-clock-alert-outline',
  [NOTIFICATION_TYPES.SYSTEM]: 'mdi-robot-outline',
};
// Vuetify color names that already resolve to the exact palette hex values approved
// for CX-21 (primary=#fc8101, success=#87C925, warning=#e9b01c are already themed in
// vuetify.js; error, blue-grey and deep-purple lighten-1 are Vuetify's own material
// colors and happen to match #ff5252 / #607d8b / #7e57c2 without any new theme entry).
export const NOTIFICATION_TYPE_COLORS = {
  [NOTIFICATION_TYPES.QUOTE]: 'primary',
  [NOTIFICATION_TYPES.BOOKING]: 'success',
  [NOTIFICATION_TYPES.REQUEST]: 'blue-grey',
  [NOTIFICATION_TYPES.DECISION]: 'error',
  [NOTIFICATION_TYPES.DEADLINE]: 'warning',
  [NOTIFICATION_TYPES.SYSTEM]: 'deep-purple lighten-1',
};
// Each role only ever receives a subset of the 6 types (see the PRD's per-role event
// taxonomy and the approved mockups) — showing all 6 filter chips to every role would
// offer filters that can never match anything.
export const NOTIFICATION_TYPES_BY_ROLE = {
  [ROLES.CLIENT]: [NOTIFICATION_TYPES.QUOTE, NOTIFICATION_TYPES.BOOKING, NOTIFICATION_TYPES.REQUEST, NOTIFICATION_TYPES.DEADLINE],
  [ROLES.COMPANY]: [NOTIFICATION_TYPES.REQUEST, NOTIFICATION_TYPES.BOOKING, NOTIFICATION_TYPES.DECISION, NOTIFICATION_TYPES.DEADLINE],
  [ROLES.ADMIN]: [NOTIFICATION_TYPES.REQUEST, NOTIFICATION_TYPES.QUOTE, NOTIFICATION_TYPES.BOOKING, NOTIFICATION_TYPES.SYSTEM],
};
